<template>
  <div class="grey lighten-5">

    <input
      ref="input"
      type="file"
      name="image"
      accept="image/*"
      @change="setImage"
    />

    <div class="content">
      <section class="cropper-area">
        <div class="img-cropper">
          <vue-cropper
            ref="cropper"
            :aspect-ratio="16 / 16"
            :src="imgSrc"
            preview=".preview"
          />
        </div>
        <div class="actions">
          <a   href="#"  v-if="!this.cropImg"   role="button"   @click.prevent="showFileChooser"  > Carregar Imagem</a>

           <a  href="#"  v-if="!this.cropImg"  role="button"  @click.prevent="cropImage"  >Cortar </a>

        </div>

        <textarea v-model="data" />
      </section>
      <section class="preview-area">
       <!-- <p>Preview</p>
        <div class="preview" />  -->
 <v-btn
                  @click="backTodisciplinList()"
                  class="mx-2"
                  fab
                  dark
                  color="primary"
                >
          <v-icon dark>arrow_back</v-icon>
        </v-btn>
        <p>Foto Pessoal</p>
        <div class="cropped-image">
          <img
            v-if="cropImg"
            :src="cropImg"
            alt="Cropped Image"
          />
          <div v-else class="crop-placeholder" />
        </div>
         <div class="actions">
        <a  href="#" v-if="this.cropImg"  role="button"  @click.prevent="guardar"  >Guardar</a>
           <a  href="#" v-if="this.cropImg"  role="button"  @click.prevent="reset"  >Cancelar</a>
</div>
      </section>
    </div>
  </div>
</template>

<script>
import axios from '../../plugins/axios'
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'
const ls = require('local-storage')
export default {
  components: {
    VueCropper
  },
  data () {
    return {
      imgSrc: '/assets/images/berserk.jpg',
      cropImg: '',
      data: null
    }
  },
  methods: {
    backTodisciplinList () {
      this.$router.push('perfil')
    },
    async guardar () {
      let respostaAPI
      try {
        this.isLoading = true

        let par = {
          base: this.cropImg,
          nameFile: ls.get('username'),
          path: 'photoPerfil/'
        }
        await axios({
          method: 'post',
          url: ls.get('urlReport') + 'image-save',
          data: par

        }).then(function (response) {
          respostaAPI = response
        })
        if (respostaAPI.status === 200) {
          this.updateFieldPhotoInPessoa()
        }
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async updateFieldPhotoInPessoa () {
      this.isLoading = true
      let valor =
                  {
                    foto: ls.get('urlReport') + '' + ls.get('username'),
                    idPessoa: ls.get('idPessoa')
                  }
      try {
        let photoUpdate = await axios
          .post('/photoUser', valor)
          .then(res => res.data)
        this.isLoading = false
        this.$router.push('perfil')
      } catch (error) {
      }
    },
    cropImage () {
      // get image data for post processing, e.g. upload or setting image src

      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL()
    },

    flipX () {
      const dom = this.$refs.flipX
      let scale = dom.getAttribute('data-scale')
      scale = scale ? -scale : -1
      this.$refs.cropper.scaleX(scale)
      dom.setAttribute('data-scale', scale)
    },
    flipY () {
      const dom = this.$refs.flipY
      let scale = dom.getAttribute('data-scale')
      scale = scale ? -scale : -1
      this.$refs.cropper.scaleY(scale)
      dom.setAttribute('data-scale', scale)
    },
    getCropBoxData () {
      this.data = JSON.stringify(this.$refs.cropper.getCropBoxData(), null, 4)
    },
    getData () {
      this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4)
    },
    move (offsetX, offsetY) {
      this.$refs.cropper.move(offsetX, offsetY)
    },
    reset () {
      this.$refs.cropper.reset()
      this.cropImg = null
    },
    rotate (deg) {
      this.$refs.cropper.rotate(deg)
    },
    setCropBoxData () {
      if (!this.data) return
      this.$refs.cropper.setCropBoxData(JSON.parse(this.data))
    },
    setData () {
      if (!this.data) return
      this.$refs.cropper.setData(JSON.parse(this.data))
    },
    setImage (e) {
      const file = e.target.files[0]
      if (file.type.indexOf('image/') === -1) {
        alert('Please select an image file')
        return
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader()
        reader.onload = (event) => {
          this.imgSrc = event.target.result
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result)
        }
        reader.readAsDataURL(file)
      } else {
        alert('Sorry, FileReader API not supported')
      }
    },
    showFileChooser () {
      this.$refs.input.click()
    },
    zoom (percent) {
      this.$refs.cropper.relativeZoom(percent)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
body {
  font-family: Arial, Helvetica, sans-serif;
  width: 100%;
  margin: 0 auto;
}
input[type="file"] {
  display: none;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0 5px 0;
}
.header h2 {
  margin: 0;
}
.header a {
  text-decoration: none;
  color: black;
}
.content {
  display: flex;
  justify-content: space-between;
}
.cropper-area {
  width: 614px;
}
.actions {
  margin-top: 1rem;
}
.actions a {
  display: inline-block;
  padding: 5px 15px;
  background: #0062CC;
  color: white;
  text-decoration: none;
  border-radius: 3px;
  margin-right: 1rem;
  margin-bottom: 1rem;
}
textarea {
  width: 100%;
  height: 100px;
}
.preview-area {
  width: 307px;
}
.preview-area p {
  font-size: 1.25rem;
  margin: 0;
  margin-bottom: 1rem;
}
.preview-area p:last-of-type {
  margin-top: 1rem;
}
.preview {
  width: 100%;
  height: calc(372px * (9 / 16));
  overflow: hidden;
}
.crop-placeholder {
  width: 100%;
  height: 200px;
  background: #ccc;
}
.cropped-image img {
  max-width: 100%;
}
</style>
